import React from "react";
import EventosCard from "./EventosCard";

const EventosGrid = ({ eventos, selectedCategoria, selectedSubCategoria, tipoAcreditacion }) => {
  const filteredEventos = eventos.filter((evento) => {
    if (selectedCategoria) {
      if (selectedSubCategoria) {
        return (
          evento.nombreDeporte === selectedCategoria &&
          evento.categoriaDeporte === selectedSubCategoria
        );
      }
      return evento.nombreDeporte === selectedCategoria;
    }
    return true;
  });

  return (
    <div className="general-container row row-cols-1 row-cols-lg-3 g-3 mb-5">
      {filteredEventos.map((evento, i) => (
        <div className="col card-container" key={i}>
          <EventosCard
            id={evento.id}
            lugar={evento.lugar}
            categoria={evento.nombreDeporte}
            subcategoria={evento.categoriaDeporte}
            fecha={evento.fecha}
            nombreEquipo1={evento.equipo1}
            nombreEquipo2={evento.equipo2}
            fotoEquipo1={evento.fotoEscudoEquipo1}
            fotoEquipo2={evento.fotoEscudoEquipo2}
            fotoIconoDeporte={evento.fotoIconoDeporte}
            nombreEvento={evento.nombre}
            inicioAcreditacion={evento.fechaInicioAcreditacion}
            finAcreditacion={evento.fechaFinalAcreditacion}
            fechaInicioRespuesta={evento.fechaInicioRespuesta}
            fechaFinalRespuesta={evento.fechaFinalRespuesta}
            isAcreditable={parseInt(evento.acreditacionHabilitada)}
            inicioAcreditacionFotografo={evento.fechaInicioAcreditacionFotografo}
            finAcreditacionFotografo={evento.fechaFinalAcreditacionFotografo}
            fechaInicioRespuestaFotografo={evento.fechaInicioRespuestaFotografo}
            fechaFinalRespuestaFotografo={evento.fechaFinalRespuestaFotografo}
            isAcreditableFotografo={parseInt(evento.acreditacionHabilitadaFotografo)}
            fechaCambioPeriodista={evento.fechaCambioPeriodista}
            tipoAcreditacion={tipoAcreditacion}
            key={evento.id}
          />
        </div>
      ))}
    </div>
  );
};

export default EventosGrid;
